import {
  CLEAR_NOTICE,
  CLEAR_STATE,

  DELETE_NOTICE,
  DELETE_NOTICE_ERROR,
  DELETE_NOTICE_SUCCESS,

  GET_NOTICE,
  GET_NOTICE_ERROR,
  GET_NOTICE_SUCCESS,

  GET_NOTICES,
  GET_NOTICES_ERROR,
  GET_NOTICES_SUCCESS,

  SAVE_NOTICE,
  SAVE_NOTICE_ERROR,
  SAVE_NOTICE_SUCCESS,

  CREATE_NOTICE,
  CREATE_NOTICE_ERROR,
  CREATE_NOTICE_SUCCESS,

  GET_RECURRENCY,
  GET_RECURRENCY_ERROR,
  GET_RECURRENCY_SUCCESS,

  SEND_MAILTO_USER,
  SEND_MAILTO_USER_SUCCESS,
  SEND_MAILTO_USER_ERROR,

  SEND_TO,
  SEND_TO_SUCCESS,
  SEND_TO_ERROR,

  GET_COOWNERS_FIELDS,
  GET_COOWNERS_FIELDS_ERROR,
  GET_COOWNERS_FIELDS_SUCCESS,

  GET_COOWNERS_USER,
  GET_COOWNERS_USER_ERROR,
  GET_COOWNERS_USER_SUCCESS,

  SEND_NOTICE,
  SEND_NOTICE_ERROR,
  SEND_NOTICE_SUCCESS,

  GET_CUSTOM_PLACEHOLDER,
  GET_CUSTOM_PLACEHOLDER_ERROR,
  GET_CUSTOM_PLACEHOLDER_SUCCESS,

  UPDATE_NOTICE_MAIL,

} from './constants';

export default {
  // [CREATE_NOTICE](state) {
  //   state.error = false;
  //   state.success = false;
  //   state.exportSuccess = false;
  //   state.exportLoading = false;
  //   state.loading = false;
  //   state.notices = [];
  //   state.notice = {};
  //   state.coownersFields = false;
  //   state.coownerUser = false;
  //   state.sendNoticeToUser = false;
  // },
  [CLEAR_NOTICE](state) {
    state.notice = {
      title: null,
      content: null,
      createdBy: null,
      sendToUsersID: null,
      recurrencyID: null,
      sendIfCoownersFieldID: null,
      sendIfType: null,
    };
    state.sendNoticeToUser = {
      noticeID: null,
      coownerUsersID: null,
    };
  },

  [CLEAR_STATE](state) {
    state.error = false;
    state.success = false;
  },

  [DELETE_NOTICE](state) {
    state.success = false;
    state.error = false;
    state.loading = true;
  },
  [DELETE_NOTICE_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.loading = false;
  },
  [DELETE_NOTICE_SUCCESS](state) {
    state.success = true;
    state.notices = false;
    state.loading = false;
  },

  [GET_NOTICE](state) {
    state.notice = {};
    state.error = false;
    state.loading = true;
  },
  [GET_NOTICE_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_NOTICE_SUCCESS](state, payload) {
    state.notice = payload;
    state.loading = false;
  },

  [GET_RECURRENCY](state) {
    state.category = false;
    state.error = false;
    state.loading = true;
  },
  [GET_RECURRENCY_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_RECURRENCY_SUCCESS](state, payload) {
    state.recurrency = payload;
    state.loading = false;
  },

  [GET_COOWNERS_FIELDS](state) {
    state.error = false;
    state.loading = true;
  },
  [GET_COOWNERS_FIELDS_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_COOWNERS_FIELDS_SUCCESS](state, payload) {
    state.coownersFields = payload;
    state.loading = false;
  },

  [GET_COOWNERS_USER](state) {
    state.error = false;
    state.loading = true;
  },
  [GET_COOWNERS_USER_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_COOWNERS_USER_SUCCESS](state, payload) {
    state.coownerUser = payload;
    state.loading = false;
  },

  [GET_NOTICES](state) {
    state.error = false;
    state.loading = true;
  },
  [GET_NOTICES_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_NOTICES_SUCCESS](state, payload) {
    // eslint-disable-next-line arrow-body-style
    const data = payload.data.map((m, i) => {
      return {
        ...m,
        sendToUser: m.sendToUserID,
        [`sendToUserID${i}`]: m.sendToUserID,
      };
    });
    state.notices = data;
    state.paging = payload.paging;
    state.loading = false;
  },

  [SEND_MAILTO_USER](state) {
    state.error = false;
    state.success = false;
    // state.formLoading = true;
  },
  [SEND_MAILTO_USER_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.formLoading = false;
  },
  [SEND_MAILTO_USER_SUCCESS](state) {
    state.success = true;
    // state.formLoading = false;
  },

  [SEND_TO](state) {
    state.success = false;
    state.sendMailSuccess = false;
    state.error = false;
    // state.loading = true;
  },
  [SEND_TO_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    // state.loading = false;
  },
  [SEND_TO_SUCCESS](state, payload) {
    state.sendMailSuccess = payload;
    state.success = true;
    // state.loading = false;
  },

  [SAVE_NOTICE](state) {
    state.error = false;
    state.success = false;
    state.formLoading = true;
  },
  [SAVE_NOTICE_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.formLoading = false;
  },
  [SAVE_NOTICE_SUCCESS](state, payload) {
    state.notice = payload;
    // state.preventNew = false;
    state.success = true;
    state.formLoading = false;
  },

  [CREATE_NOTICE](state) {
    state.error = false;
    state.success = false;
    state.loading = true;
    state.noticeCreated = 0;
  },
  [CREATE_NOTICE_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.loading = false;
  },
  [CREATE_NOTICE_SUCCESS](state, payload) {
    state.success = true;
    state.loading = false;
    state.noticeCreated = payload;
  },

  [SEND_NOTICE](state) {
    state.error = false;
    state.success = false;
    state.loading = true;
  },
  [SEND_NOTICE_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.loading = false;
  },
  [SEND_NOTICE_SUCCESS](state, payload) {
    state.success = true;
    state.loading = false;
    state.sendNoticeToUser = payload;
  },

  [UPDATE_NOTICE_MAIL](state, payload) {
    state.notices[payload.rowIndex][payload.id] = payload.event.value;
    state.notices[payload.rowIndex].sendToUser = payload.event.value;
  },

  [GET_CUSTOM_PLACEHOLDER](state) {
    state.error = false;
    state.loading = true;
  },
  [GET_CUSTOM_PLACEHOLDER_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_CUSTOM_PLACEHOLDER_SUCCESS](state, payload) {
    state.getNoticePlaceholder = payload;
    state.loading = false;
  },


  // single object item mutation
  updateItem(state, payload) {
    state.notice[payload.item] = payload.value;
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Information/Notices/mutations.js